// components/SessionTimer.tsx
import { useEffect } from 'react';
import useSessionTimer from '../../hooks/useSessionTimer';
import useAdminUserStore from '../../store/adminUserStore';

const SessionTimer = () => {
  const remainingTime = useSessionTimer();
  const logout = useAdminUserStore((state) => state.logout);

  useEffect(() => {
    if (remainingTime !== null && remainingTime <= 0) {
      logout();
    }
  }, [remainingTime, logout]);

  if (remainingTime === null || remainingTime <= 0) return null;

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;

  return (
    <div className="admin-session-timer">
       {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </div>
  );
};

export default SessionTimer;